import { ChangeDetectionStrategy, ChangeDetectorRef, Component, NgZone, OnInit } from '@angular/core';
import { PaginatorService } from '../../Services/PaginatorService';

@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaginatorComponent implements OnInit {
  constructor(
    public paginatorService: PaginatorService,
    private cdr: ChangeDetectorRef,
    private ngZone: NgZone
    ) {}

  ngOnInit(): void {
    // perform any initialization logic here
  }

  setPagination(event: any): void {
    this.ngZone.run(() => {
      this.paginatorService.paginatorConfig.pageIndex = event.pageIndex;
      this.paginatorService.paginatorConfig.pageSize = event.pageSize;
      this.cdr.detectChanges();
      this.paginatorService.emitPaginationEvent(event);
    });
  }
  
}
